import { DataFilters } from "@ac-expo/api-types";
import { privateAxios } from "../axiosInstances";
import { useMutation } from "@tanstack/react-query";

const exportOrganiserData = async (filters?: DataFilters) => {
  const { data } = await privateAxios.get<Blob>(`/data/organisers`, {
    params: filters,
    responseType: "blob",
  });
  return data;
};

export const useExportOrganiserData = () => {
  return useMutation({
    mutationFn: (filters?: DataFilters) => exportOrganiserData(filters),
  });
};

const exportStructureData = async (filters?: DataFilters) => {
  const { data } = await privateAxios.get<Blob>(`/data/structures`, {
    params: filters,
    responseType: "blob",
  });
  return data;
};

export const useExportStructureData = () => {
  return useMutation({
    mutationFn: (filters?: DataFilters) => exportStructureData(filters),
  });
};

const exportOrganiserValidatedEventsData = async (filters?: DataFilters) => {
  const { data } = await privateAxios.get<Blob>(
    `/data/organisers-validated-events`,
    {
      params: filters,
      responseType: "blob",
    }
  );
  return data;
};

export const useExportOrganiserValidatedEventsData = () => {
  return useMutation({
    mutationFn: (filters?: DataFilters) =>
      exportOrganiserValidatedEventsData(filters),
  });
};
